import * as React from "react";
import { AppLayout, ILeadAction, Lead, useLead360 } from "../../../core";
import "../../../styles/full-view-popup.scss";
import "../../../styles/sales-person.scss";
import "../../../styles/tags.scss";
import "../../../styles/requirement.scss";

import { ActivityCategory, PropertyDetailTabNames } from "./props";
import PropertyDetailTabs from "../../requirement-detail-popup/PropertyDetailTabs";
import ProjectOverview from "../../requirement-detail-popup/project-overview";
import PropertyUnit from "../../requirement-detail-popup/propertyUnit";
import api from "../../../api";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import { Project, PropertyDetails } from "../../../core/api/models/project";
import { ContainerLoader } from "../../../components/loader";
import { toastr } from "react-redux-toastr";
import { LeadRequirement } from "../../../core/api/models/requirement";
import PropertyDetailPage from "../../property-details/PropertyDetailPage";
import Lead360Activities from "../../global-search/components/Lead360Activities";
import ActionModal from "../../lead-360-view/components/lead-details/actions/ActionModal";

interface IPropertyDetailsPageProps {
  onClose: () => void;
  projectId?: string;
  type?: string;
  searchData?: Project;
  requirementVersion?: number;
  requirementId?: string;
  availableUnit?: number;
  allUnit?: number;
  configuration?: LeadRequirement;
  showDetailsOnly?: boolean;
  reload?: () => void;
}

const RequirementPropertyDetailPage: React.FunctionComponent<
  IPropertyDetailsPageProps
> = (props) => {
  const [propertyDetailTabName, setPropertyDetailTabName] =
    React.useState<PropertyDetailTabNames>(PropertyDetailTabNames.Overview);
  const handlePropertyDetailTabChange = (
    tabNameValue: PropertyDetailTabNames
  ) => {
    setPropertyDetailTabName(tabNameValue);
  };

  const [detailModal, setDetailModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
  }>({});

  const [reloadActivity, setReloadActivity] = React.useState(false)
  const [actionDetailsData, setActionDetailsData] = React.useState<{
    isModalOpen?: boolean;
    action?: ILeadAction;
    leads?: Lead[];
  }>({});
  const { allLeads, company, reload } = useLead360(api.lead);
  const [selectedProperty, setSelectedProperty] =
    React.useState<PropertyDetails[]>();

  const {
    data: project,
    loading,
    loaded,
  } = useDataLoader<Project>(() =>
    api.project.getProjectDetails(props.projectId!)
  );

  const [detailsLoaded, setISLoaded] = React.useState(false);

  React.useEffect(() => {
    if (loaded) {
      const timer = setTimeout(() => {
        setISLoaded(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [loaded]);

  const {
    performAction: createShortList,
    isPerforming: isSaving,
  } = usePerformAction(
    () =>
      api.shortlist.createShortList({
        requirementId: props.requirementId!,
        propertyDetails: selectedProperty!,
      }),
    () => {
      toastr.success("Success", "Added to Shortlist");
      props.reload?.()
      props.onClose();

    },
    () => {
      toastr.error("Error", "Unable to add to Shortlist");
    }
  );

  const {
    performAction: mergePropeties,
    isPerforming: isMerging,
  } = usePerformAction(
    () =>
      api.shortlist.mergePropeties({
        requirementId: props.requirementId!,
        propertyDetails: selectedProperty!,
        requirementVersion: props.requirementVersion
      }),
    () => {
      toastr.success("Success", "Merged units");
      props.reload?.()
      props.onClose();
      window.location.reload();

    },
    () => {
      toastr.error("Error", "Unable to merge units.");
    }
  );

  const {
    performAction: splitUnitsAndProperties,
    isPerforming: isSpliting,
  } = usePerformAction(
    (propertyId: string, unitId: string, splitPropertyDetails: any[]) =>
      api.property.splitUnits({
        requirementId: props.requirementId!,
        propertyId,
        unitId,
        splitPropertyDetails,
      }),
    () => {
      toastr.success("Success", "Split units");
      props.reload?.()
      props.onClose();

    },
    () => {
      toastr.error("Error", "Unable to split units.");
    }
  );


  const renderHeader = () => {
    return (
      <div className="container-fluid bg-gray-100 border-bottom py-4 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div
            className="col-auto font-md font-weight-semibold text-gray-500 d-flex align-items-center cursor-pointer"
            onClick={props.onClose}>
            <i className="icon-chevron-left text-gray-500 font-base cursor-pointer mr-2"></i>
            Back
          </div>
          {!props.showDetailsOnly && (
            <div className="col d-flex justify-content-end">
              <button
                className="btn bg-primary px-3 font-normal font-weight-bold text-white"
                disabled={!selectedProperty?.length || isSaving}
                onClick={createShortList}>
                Add to Shortlist
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  const otherAction: ILeadAction = {
    name: "Create Activity",
    code: "call",
    _id: "call",
  };

  const addActivity = () => {
    setActionDetailsData({
      isModalOpen: true,
      action: otherAction,
      leads: allLeads,
    });
  }

  return (
    <AppLayout>
      <div className="" style={{ zIndex: 9999}}>
        <>
          <div className="detail-poupup position-fixed top-0 w-100 h-100 overflow-auto in">
            {renderHeader()}
            <div className="container-fluid px-4 bg-white min-vh-100 pt-3 pb-5">
              {detailsLoaded ? (
                <>
                  <div className="">
                    <PropertyDetailTabs
                      tabName={propertyDetailTabName}
                      tabChangeHandler={handlePropertyDetailTabChange}
                    />
                  </div>
                  {PropertyDetailTabNames.Overview ===
                    propertyDetailTabName && (
                      <ProjectOverview
                        project={project}
                        mergePropeties={mergePropeties}
                        isSpliting={isSpliting}
                        isMerging={isMerging}
                        splitUnitsAndProperties={splitUnitsAndProperties}
                        searchData={props.searchData}
                        requirementVersion={props.requirementVersion}
                        setSelectedProperty={setSelectedProperty}
                        selectedProperty={selectedProperty}
                        availableUnit={props.availableUnit}
                        allUnit={props.allUnit}
                        configuration={props.configuration!}
                        showDetailsOnly={props.showDetailsOnly}
                        onClose={props.onClose}
                        onView={(id: string) =>
                          setDetailModal({
                            isOpen: true,
                            id,
                          })
                        }
                      />
                    )}
                  {PropertyDetailTabNames.UnitInfo ===
                    propertyDetailTabName && (
                      <PropertyUnit
                        project={project}
                        availableUnit={props.availableUnit}
                        allUnit={props.allUnit}
                        onView={(id: string) =>
                          setDetailModal({
                            isOpen: true,
                            id,
                          })
                        }
                      />
                    )}
                  {PropertyDetailTabNames.Activities ===
                    propertyDetailTabName && (
                        <Lead360Activities
                          leads={[]}
                           cssClass="addactivity-wrap"
                          activityCategory={ActivityCategory.Project}
                          activityCategoryId={props.projectId}
                          addActivity={() => { addActivity(); setReloadActivity(false) }}
                          reloadActivity={reloadActivity} />
                    )}
                  {PropertyDetailTabNames.LocationMap ===
                    propertyDetailTabName && (
                      <div className="pt-3">
                        <div className="col-12 px-0">
                          <h2 className="mb-4">Location Map</h2>
                        </div>
                        <div
                          className="col px-0 mb-3"
                          style={{ maxWidth: "626px" }}
                        >
                          <iframe
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDswP272vF5WZVy9n8lBai1df9bbuvzblI&q=${project?.projectAddress1}`}
                            width="626"
                            height="315"
                            loading="lazy"
                            className="border-0"
                          ></iframe>
                        </div>
                        <div className="col-12 px-0 font-sm">
                          <div className="mb-1">{project?.city?.cityName}</div>
                          <div>
                            <i className="icon-location-filled mr-2 text-gray-500"></i>
                            {project?.projectAddress1}
                          </div>
                        </div>
                      </div>
                    )}
                </>
              ) : (
                <>
                  <ContainerLoader></ContainerLoader>
                </>
              )}
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      </div>

      {detailModal.isOpen && (
        <PropertyDetailPage
          onClose={() => setDetailModal({})}
          projectId={detailModal.id}></PropertyDetailPage>
      )}
      {/* project  */}
          {actionDetailsData.isModalOpen && (
            <ActionModal
              onClose={() => setActionDetailsData({})}
              action={actionDetailsData.action!}
              reload={() => setReloadActivity(true)}
              activityCategory={ActivityCategory.Project}
              activityCategoryId={props.projectId}
              ></ActionModal>
          )}
    </AppLayout>
  );
};

export default RequirementPropertyDetailPage;
